import { Form, FormGroup, Input, Label} from "reactstrap"
import { ISearchIndividualsForNewInput } from "../../../../types/individual"
import { useEffect, useState } from "react"
import { AddIcon, CancelIcon, SearchIcon } from "../../../common/icons"
import { ICategory, IOrg } from "../../../../types/org"
import useToggle from "../../../../hook/useToggle"
import SelectOrgModal from "./select-org"
import Button from "../../../common/button"
import { normalizeApostrophes } from "../../../../utils/commons"


type SearchIndividualProp={
    onSearchIndividual: (searchIndividualsInput:ISearchIndividualsForNewInput)=>void
    showPosition?: boolean
    onCreateNewIndividual: ()=>void
    disableCreate?: boolean
    isRole: boolean
}

const SearchIndividual = (prop:SearchIndividualProp) =>{
    const {showPosition,onSearchIndividual,onCreateNewIndividual,disableCreate, isRole} = prop;

    const [searchOrg,setSearchOrg] = useState< IOrg | undefined>();

    const [searchIndividualsInput, setSearchIndividualsInput] = useState<ISearchIndividualsForNewInput>({orgId:0,individualName:'', positionName:''})

    const { isOpen : isOrgTreeOpen, toggle : orgTreeToggle } = useToggle()

    const onNameChange = (event:any) => {
        let correctedIndividualName = normalizeApostrophes(event.target.value);
        setSearchIndividualsInput({...searchIndividualsInput,individualName:correctedIndividualName});
    }

    const onPositionRoleChange = (event:any) => {
        setSearchIndividualsInput({...searchIndividualsInput,positionName:event.target.value})
    }

    const disableSearchInd = (!showPosition && !searchIndividualsInput.individualName?.trim())
     || (showPosition && !searchIndividualsInput.individualName?.trim() && !searchIndividualsInput.positionName?.trim())

    const handleSearchClick = () => {
        onSearchIndividual(searchIndividualsInput);
    }

    const handleCreateClick = () => {
        onCreateNewIndividual();
    }

    const onSelect = (item: ICategory | IOrg | undefined) => {
        console.log("selectedOrg:",item)
        if(item&&('categoryName' in item)) {
            setSearchOrg(undefined)
        }else if(item&&('orgName' in item)){
            setSearchOrg(item);
        }
    }

    useEffect(() => {
        if(searchOrg&&('categoryName' in searchOrg)) {
            setSearchIndividualsInput({...searchIndividualsInput,orgId:0})
        }else if(searchOrg&&('orgName' in searchOrg)){
            setSearchIndividualsInput({...searchIndividualsInput,orgId:searchOrg.id});
        }
    },[searchOrg])

    // Handle key press event for Enter key
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && !disableSearchInd) {
            event.preventDefault();
            handleSearchClick();
        }
    };

    return (
        <>
            <SelectOrgModal isOpen={isOrgTreeOpen} toggle={orgTreeToggle} onSelect={onSelect}/>
            <Form>
                <FormGroup>
                    <div>
                        {!showPosition&& <div>Please search for an individual you would like to assign to this {isRole?'Role':'Position'}. You may filter by organization, if desired.</div>}
                        {showPosition&& <div>Please fill out at least one field to search for an individual to assign to the membership.</div>}
                    </div>

                    <div className='row'><div>Filter by Organization:</div></div>
                    <div className='row'>
                        <div className="col-12 flex-container" style={{marginBottom:'10px', marginTop: '10px'}}>
                            <div><Button id="filter" onClick={orgTreeToggle}><SearchIcon/>&nbsp;Search Organization</Button></div>
                            <div>&nbsp;&nbsp;{searchOrg?searchOrg.orgName:'All'}</div>
                            {searchOrg && (
                                <button
                                    style={{
                                        marginLeft: '10px',
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        transition: 'color 0.3s',
                                    }}
                                    onClick={() => setSearchOrg(undefined)}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = 'gray'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
                                >
                                    <CancelIcon/>
                                </button>
                            )}
                        </div>
                    </div>
                    {showPosition && <>
                        <div className='row top-5px'>
                            <div className="col-4"><Label for="postionRoleTitle">Position/Role Title:</Label></div>

                            <div className="col-8">
                                <Input id='postionRoleTitle' placeholder="Enter a position or role title" onChange={onPositionRoleChange} />
                            </div>
                        </div>
                    </>
                    }

                    <div className='row top-5px'>
                        <div className="col-4">
                            <Label for="individualName">Individual Name:</Label></div>
                        <div className="col-8">
                            <Input id='individualName' placeholder="Username" onChange={onNameChange} onKeyDown={handleKeyDown}/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 flex-container ">
                            <div><Button style={{marginBottom:'10px', marginTop: '15px'}} onClick={handleSearchClick} disabled={ disableSearchInd }><SearchIcon/>&nbsp;Search Individual</Button></div>
                            <div>&nbsp;&nbsp;<Button style={{marginBottom:'10px', marginTop: '15px'}} onClick={handleCreateClick} disabled={disableCreate}><AddIcon/>&nbsp;Create New Individual</Button></div>
                        </div>
                    </div>

                </FormGroup>
            </Form>
        </>
    )

}

export default SearchIndividual
